import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punemumbaitaxiservice() {



  const cardData = {


  keyword: "Pune Mumbai Taxi Service",

  headingDescription: "Trustline Cab provides reliable Pune Mumbai taxi service with safe, comfortable, and affordable transportation solutions for business trips, airport transfers, corporate travel, family vacations, and outstation journeys. Whether you need a one-way cab, round trip taxi, or customized travel package, our experienced chauffeurs ensure timely pickups and a smooth journey between Pune and Mumbai. Our fleet includes AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and luxury cars suitable for every travel requirement. With transparent pricing, doorstep pickup, easy online booking, well-maintained vehicles, and 24/7 customer support, Trustline Travels is a trusted choice for hassle-free Pune to Mumbai taxi services.",

  topPlaces: [
    {
      title: "BKC (Bandra Kurla Complex)",
      description: "Bandra Kurla Complex is Mumbai's leading commercial and financial district, featuring multinational companies, corporate headquarters, banks, convention centers, and premium office spaces. It is one of the most preferred destinations for business travelers and professionals visiting Mumbai from Pune."
    },
    {
      title: "Lower Parel",
      description: "Lower Parel is a major business and lifestyle destination in Mumbai, known for corporate towers, financial companies, luxury hotels, shopping centers, and premium restaurants. The area attracts professionals, executives, and visitors for business meetings and corporate events."
    },
    {
      title: "Andheri East",
      description: "Andheri East is one of Mumbai's busiest commercial areas, offering IT parks, corporate offices, business hotels, and excellent connectivity to Mumbai Airport. It is a popular destination for corporate travelers, airport passengers, and professionals visiting the city."
    },
    {
      title: "Thane",
      description: "Thane is a rapidly developing city in the Mumbai Metropolitan Region, known for business parks, residential projects, shopping destinations, and excellent infrastructure. It serves as an important destination for corporate travel, family visits, and commercial activities."
    },
    {
      title: "Navi Mumbai",
      description: "Navi Mumbai is a planned city featuring IT parks, industrial zones, corporate offices, logistics hubs, and modern residential areas. It is a preferred destination for business travelers due to locations like Airoli, Vashi, Belapur, and Mahape."
    },
    {
      title: "Airoli",
      description: "Airoli is a major IT and business hub in Navi Mumbai, home to multinational companies, technology parks, financial organizations, and corporate campuses. It attracts thousands of professionals and business travelers every day."
    },
    {
      title: "Juhu Beach",
      description: "Juhu Beach is one of Mumbai's most famous tourist attractions, known for its beautiful coastline, street food, celebrity residences, and relaxing evening atmosphere. It is a popular place for visitors exploring Mumbai after business or leisure trips."
    },
    {
      title: "Marine Drive",
      description: "Marine Drive is Mumbai's iconic seaside promenade, famous for stunning Arabian Sea views, evening walks, and the beautifully illuminated Queen's Necklace skyline. It is one of the most visited attractions for tourists and first-time visitors to Mumbai."
    },
    {
      title: "Elephanta Caves",
      description: "Elephanta Caves is a UNESCO World Heritage Site located near Mumbai, famous for ancient rock-cut temples and impressive sculptures dedicated to Lord Shiva. Visitors enjoy a scenic ferry ride from Gateway of India to explore this historic destination."
    },
    {
      title: "Bandra-Worli Sea Link",
      description: "Bandra-Worli Sea Link is a world-famous infrastructure landmark connecting western suburbs with South Mumbai. The bridge offers beautiful views of the Arabian Sea and provides a memorable driving experience for travelers visiting Mumbai."
    }
  ],






"services": [
  {
    "name": "Pune Mumbai Taxi Service",
    "description": "Book Pune Mumbai Taxi Service for safe, comfortable, and reliable intercity travel between Pune and Mumbai. Enjoy professional chauffeur-driven Sedan, Ertiga, Innova Crysta, Kia Carens, SUV, and premium vehicles for one-way trips, round trips, airport transfers, corporate travel, family journeys, Mumbai Darshan tours, and business travel with doorstep pickup, transparent pricing, clean AC cars, flexible schedules, and 24x7 customer assistance."
  },
  {
    "name": "Best Cab Service Pune to Mumbai",
    "description": "Choose the Best Cab Service Pune to Mumbai for affordable and comfortable long-distance transportation with experienced drivers, well-maintained vehicles, and multiple cab options. Our Pune to Mumbai cab service is suitable for airport drops, railway station transfers, corporate meetings, family trips, and outstation travel with reliable booking support."
  },
  {
    "name": "Pune to Mumbai Cab Fare",
    "description": "Check Pune to Mumbai Cab Fare with transparent pricing for Sedan, Ertiga, Innova Crysta, SUV, and premium cars. Get affordable rates for one-way cab booking, round-trip travel, airport transfers, and private taxi services without hidden charges."
  },
  {
    "name": "Pune to Mumbai International Airport Cab",
    "description": "Book Pune to Mumbai International Airport Cab for timely airport transfers with professional drivers, spacious luggage capacity, comfortable AC vehicles, and reliable pickup service. Travel conveniently from Pune to Mumbai Airport with affordable fares and smooth highway travel."
  },
  {
    "name": "Pune to Mumbai Airport Cab Price",
    "description": "Find Pune to Mumbai Airport Cab Price with competitive rates for different vehicle categories including Sedan, Ertiga, Innova Crysta, and luxury cars. Enjoy fixed pricing, experienced chauffeurs, and comfortable airport transportation."
  },
  {
    "name": "Pune to Mumbai Innova Cab",
    "description": "Hire Pune to Mumbai Innova Cab for premium family and corporate travel with spacious seating, luggage comfort, professional drivers, and smooth highway journeys. Ideal for airport drops, business trips, and long-distance travel."
  },
  {
    "name": "Pune to Mumbai Cab Booking",
    "description": "Complete Pune to Mumbai Cab Booking online with instant confirmation, multiple vehicle options, affordable fares, doorstep pickup, and professional chauffeur service for a hassle-free travel experience."
  },
  {
    "name": "Pune to Mumbai Airport Taxi",
    "description": "Book Pune to Mumbai Airport Taxi for reliable airport pickup and drop services with punctual drivers, clean AC vehicles, and comfortable travel from Pune to Mumbai Airport."
  },
  {
    "name": "Pune Mumbai Cab One Way",
    "description": "Choose Pune Mumbai Cab One Way service for direct destination travel with affordable pricing, professional drivers, and premium vehicles without return fare charges."
  },
  {
    "name": "Pune Mumbai Car Hire",
    "description": "Hire Pune Mumbai Car Rental service with chauffeur-driven Sedan, Ertiga, Innova Crysta, SUV, and luxury vehicles for business travel, family trips, airport transfers, and private journeys."
  },
  {
    "name": "Pune to Mumbai Darshan Cab",
    "description": "Book Pune to Mumbai Darshan Cab for sightseeing tours and city exploration with comfortable vehicles, experienced drivers, flexible schedules, and customized Mumbai Darshan packages from Pune."
  },
  {
    "name": "Pune to Mumbai Taxi Price",
    "description": "Check Pune to Mumbai Taxi Price for affordable intercity travel with transparent fares, multiple vehicle choices, and reliable taxi service for one-way and round-trip journeys."
  },
  {
    "name": "Best Mumbai Pune Cab Service",
    "description": "Choose the Best Mumbai Pune Cab Service for comfortable return journeys with professional chauffeurs, premium vehicles, affordable pricing, and 24x7 booking support."
  },
  {
    "name": "Cab Services Pune to Mumbai",
    "description": "Our Cab Services Pune to Mumbai provide safe and convenient transportation with Sedan, Ertiga, Innova Crysta, SUV, and luxury cars for personal, corporate, and airport travel."
  },
  {
    "name": "Pune Mumbai Cab Service",
    "description": "Book Pune Mumbai Cab Service for reliable intercity transportation with clean vehicles, skilled drivers, transparent fares, and flexible travel options including one-way and round trips."
  },
  {
    "name": "Pune to Mumbai Taxi",
    "description": "Travel comfortably with Pune to Mumbai Taxi service offering affordable fares, AC vehicles, professional drivers, and convenient pickup locations across Pune."
  },
  {
    "name": "Pune to Mumbai Cab",
    "description": "Book Pune to Mumbai Cab for safe and comfortable travel with premium vehicles, experienced chauffeurs, airport connectivity, corporate transportation, and family travel options."
  },
  {
    "name": "Mumbai to Pune Taxi",
    "description": "Hire Mumbai to Pune Taxi for convenient return travel with doorstep pickup, clean AC cars, experienced drivers, and affordable intercity transportation."
  },
  {
    "name": "Mumbai to Pune Cab",
    "description": "Choose Mumbai to Pune Cab service for reliable travel with multiple vehicle options, transparent pricing, professional chauffeurs, and comfortable long-distance journeys."
  },
  {
    "name": "Pune Mumbai Taxi Booking",
    "description": "Complete Pune Mumbai Taxi Booking online with easy reservation, instant confirmation, affordable pricing, and premium taxi options for every travel requirement."
  },
  {
    "name": "Pune Mumbai Cab Booking",
    "description": "Book Pune Mumbai Cab Booking service for hassle-free travel with flexible booking options, professional drivers, and well-maintained vehicles."
  },
  {
    "name": "Online Pune Mumbai Taxi Booking",
    "description": "Use Online Pune Mumbai Taxi Booking for quick cab reservations with instant confirmation, transparent pricing, and reliable chauffeur-driven travel."
  },
  {
    "name": "Book Pune Mumbai Taxi",
    "description": "Book Pune Mumbai Taxi for airport transfers, business travel, family trips, and outstation journeys with comfortable AC vehicles and experienced drivers."
  },
  {
    "name": "Pune Mumbai Intercity Taxi",
    "description": "Pune Mumbai Intercity Taxi service offers safe highway travel with premium cars, professional chauffeurs, affordable fares, and flexible travel solutions."
  },
  {
    "name": "Pune Mumbai Outstation Taxi",
    "description": "Choose Pune Mumbai Outstation Taxi for reliable long-distance travel with clean vehicles, trained drivers, and comfortable journeys."
  },
  {
    "name": "Pune Mumbai Private Taxi",
    "description": "Hire Pune Mumbai Private Taxi for exclusive travel with privacy, flexible pickup, premium vehicles, and professional chauffeur service."
  },
  {
    "name": "Pune Mumbai AC Taxi",
    "description": "Book Pune Mumbai AC Taxi with comfortable air-conditioned vehicles, experienced drivers, and smooth travel experience between Pune and Mumbai."
  },
  {
    "name": "Pune Mumbai Travel Cab",
    "description": "Choose Pune Mumbai Travel Cab for family trips, corporate journeys, airport transfers, and sightseeing travel with reliable service."
  }
],

"tableData": [
  ["Pune Mumbai Taxi Service", "Best Cab Service Pune to Mumbai"],
  ["Pune to Mumbai Cab Fare", "Pune to Mumbai International Airport Cab"],
  ["Pune to Mumbai Airport Cab Price", "Pune to Mumbai Innova Cab"],
  ["Pune to Mumbai Cab Booking", "Pune to Mumbai Airport Taxi"],
  ["Pune Mumbai Cab One Way", "Pune Mumbai Car Hire"],
  ["Pune to Mumbai Darshan Cab", "Pune to Mumbai Taxi Price"],
  ["Best Mumbai Pune Cab Service", "Cab Services Pune to Mumbai"],
  ["Pune Mumbai Cab Service", "Pune to Mumbai Taxi"],
  ["Pune to Mumbai Cab", "Mumbai to Pune Taxi"],
  ["Mumbai to Pune Cab", "Pune Mumbai Taxi Booking"],
  ["Pune Mumbai Cab Booking", "Online Pune Mumbai Taxi Booking"],
  ["Book Pune Mumbai Taxi", "Pune Mumbai Intercity Taxi"],
  ["Pune Mumbai Outstation Taxi", "Pune Mumbai Private Taxi"],
  ["Pune Mumbai AC Taxi", "Pune Mumbai Travel Cab"]
],





whychoose: [
  {
    WhyChooseheading: "Trusted Pune Mumbai Taxi Service",
    WhyChoosedescription: "Trustline Cab provides reliable Pune Mumbai taxi services with comfortable vehicles for business trips, airport transfers, family travel, and outstation journeys."
  },
  {
    WhyChooseheading: "Experienced Drivers for Mumbai Route",
    WhyChoosedescription: "Our professional chauffeurs have excellent route knowledge and ensure a safe, smooth, and timely journey between Pune and Mumbai."
  },
  {
    WhyChooseheading: "Affordable Taxi Fare with Transparency",
    WhyChoosedescription: "Get competitive Pune Mumbai taxi rates with clear quotations, fair pricing, and no hidden charges."
  },
  {
    WhyChooseheading: "Doorstep Pickup & Drop Facility",
    WhyChoosedescription: "Enjoy convenient pickup and drop services from homes, offices, hotels, Pune Airport, railway stations, and major locations."
  },
  {
    WhyChooseheading: "Multiple Taxi Options Available",
    WhyChoosedescription: "Choose from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers based on your comfort and group size."
  },
  {
    WhyChooseheading: "One Way & Round Trip Taxi Booking",
    WhyChoosedescription: "Book flexible one-way taxis, return trips, or customized travel packages from Pune to Mumbai according to your requirements."
  },
  {
    WhyChooseheading: "Airport & Corporate Travel Solutions",
    WhyChoosedescription: "Our Pune Mumbai taxi service is suitable for Mumbai Airport transfers, business meetings, office travel, and corporate transportation."
  },
  {
    WhyChooseheading: "24/7 Taxi Availability",
    WhyChoosedescription: "Book your Pune Mumbai taxi anytime with quick confirmation and dedicated customer support for hassle-free travel."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Pune Mumbai taxi service?",
    answer: "Yes, Trustline Cab offers reliable Pune Mumbai taxi services for one-way trips, round trips, airport transfers, and corporate travel."
  },
  {
    question: "Can I book a one-way taxi from Pune to Mumbai?",
    answer: "Yes, we provide affordable one-way taxi services from Pune to Mumbai with flexible pickup timings."
  },
  {
    question: "What types of taxis are available for Pune Mumbai travel?",
    answer: "We provide Sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers for comfortable journeys."
  },
  {
    question: "Do you provide Mumbai Airport taxi service from Pune?",
    answer: "Yes, we offer direct taxi services from Pune to Mumbai Airport Terminal 1 and Terminal 2."
  },
  {
    question: "Can I book a round-trip taxi between Pune and Mumbai?",
    answer: "Yes, Trustline Cab provides customized round-trip taxi packages for business, family, and sightseeing travel."
  },
  {
    question: "Are toll and parking charges included in the taxi fare?",
    answer: "Toll charges, parking fees, and applicable taxes are generally charged separately unless included in your booking quotation."
  },
  {
    question: "Is Pune Mumbai taxi service available 24/7?",
    answer: "Yes, our taxi services are available round the clock for your convenience."
  },
  {
    question: "Can I schedule my Pune Mumbai taxi in advance?",
    answer: "Yes, advance booking is recommended to ensure vehicle availability and timely pickup."
  },
  {
    question: "Do you provide taxis for corporate travel?",
    answer: "Yes, we provide professional taxi solutions for corporate employees, business meetings, and regular office travel."
  },
  {
    question: "How can I book Pune Mumbai Taxi Service with Trustline Travels?",
    answer: "Share your pickup location, destination, travel date, passenger details, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sameer Joshi",
    feedback: "Trustline Travels provided excellent Pune Mumbai taxi service for my business trip. The driver was punctual, the cab was clean, and the journey was smooth and comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Patil",
    feedback: "We booked a Pune Mumbai taxi for our family travel and had a wonderful experience. The service was reliable, the fare was transparent, and the entire trip was stress-free.",
    rating: 5
  }
];




  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Mumbai Taxi Service",
  "image": "https://www.trustlinetravels.com/assets/images/pune-mumbai-taxi-service.webp",
  "description": "Book Pune Mumbai taxi service with Trustline Travels for safe, comfortable, and affordable intercity travel. Get Pune to Mumbai airport taxi, one-way cab, round-trip taxi, and premium cab services with Sedan, Ertiga, SUV, Innova, Innova Crysta, and luxury cab options available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7826"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/pune-mumbai-taxi-service"
  }
};






  return (
    <div>
<Helmet>
  <title>Pune Mumbai Taxi Service | Airport & Outstation Cab | +91 8087080034</title>

  <meta
    name="description"
    content="Book Pune Mumbai taxi service with Trustline Travels for reliable airport and intercity travel. Get affordable Pune to Mumbai cabs with Innova, Sedan, Ertiga, SUV, and premium taxi options available 24x7."
  />

  <meta
    name="keywords"
    content="Pune mumbai taxi service, Best cab service pune to mumbai, Pune to mumbai cab fare, Pune to mumbai international airport cab, Pune to mumbai airport cab price, Pune to mumbai innova cab, Pune to mumbai cab booking, Pune to mumbai airport taxi, Pune Mumbai cab service, Pune Mumbai one way taxi, Pune Mumbai round trip cab, Pune Mumbai airport transfer, Pune to Mumbai online taxi booking"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/77.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punemumbaitaxiservice;